import Vue from 'vue'

export const state = () => ({
    list: [],
    meta: {},
})

export const mutations = {
    SET_LIST(state, data) {
        state.list = data
    },
    SET_META(state, data) {
        state.meta = data
    },
}

export const actions = {
    async getList({ commit }, payload) {
        const result = await this.$axios.$get(`/api/v1/content/list`, {
            params: payload,
        })
        commit('SET_LIST', result.data)
        commit('SET_META', result.meta)
        return result
    },
    async get({}, { url, type, slug, id, toastMessage }) {
        if (!url && (!type || !slug) && !id) throw new Error('Error: [content/get] - missing parameters')
        const result = await this.$axios.$get(`/api/v1/content?${url || (type && slug) ? `url=${url || `/${type}/${slug}`}` : `id=${id}`}`)
        if (toastMessage) this.$toast.success(toastMessage).goAway(3000)
        return result
    },
    async submitWedding({}, { model, toastMessage }) {
        const result = await this.$axios[model?.id ? '$put' : '$post'](`api/v1/content/submit-wedding${model?.id ? `/${model.id}` : ''}`, model)
        if (toastMessage) this.$toast.success(toastMessage).goAway(3000)
        return result.data
    },
    async getWeddings({}, { id, toastMessage }) {
        if (!id) throw new Error('Error: [content/getWeddings] - missing id')
        const result = await this.$axios.$get(`/api/v1/content/submit-wedding?user_id=${id}`)
        if (toastMessage) this.$toast.success(toastMessage).goAway(3000)
        return result.data || []
    },
    async submitVendor({}, { model, toastMessage }) {
        const result = await this.$axios[model.id ? '$put' : '$post'](`api/v1/content/submit-vendor${model.id ? `/${model.id}` : ''}`, model)
        if (toastMessage) this.$toast.success(toastMessage).goAway(3000)
        return result.data
    },
}

export const getters = {
    list: (state) => state.list,
    meta: (state) => state.meta,
}
